import {usePageStore} from "@/stores/pageStore.js";
import {altFor} from "@/utils/imageAlt.js";

// alt(src, ...fallbacks): the photo's description (owner's, then Pexels'), else the first fallback with words in it
// (the section's heading or caption). Reads the page's imageAlts from the store, so server and browser agree.
export function useImageAlt() {
    const page = usePageStore();
    return (src, ...fallbacks) => altFor(page.pageData?.imageAlts, src, ...fallbacks);
}
